import React, { useState, useEffect } from 'react';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import styles from './Collapse.module.scss';

const Collapse = ({
  showAdvanceParameters: initialShow,
  expandText,
  expandTextOuvert,
  children,
}) => {
  // Separate state with useState hooks
  const [isExpanded, setIsExpanded] = useState(initialShow === true);
  // Effect to handle prop changes
  useEffect(() => {
    if (initialShow === true) {
      setIsExpanded(true);
    } else if (initialShow === false) {
      setIsExpanded(false);
    }
  }, [initialShow]);

  // Event handler
  const toggleExpand = (event) => {
    event.preventDefault();
    setIsExpanded((prev) => !prev);
  };

  // Render helper functions
  const renderExpandText = () => {
    if (!expandText) return null;

    return (
      <div className={[s.text_left, s.col_10].join(' ')}>{expandText}</div>
    );
  };

  const renderExpandTextOpen = () => {
    return (
      <div className={[s.text_left, s.col_10].join(' ')}>
        {expandTextOuvert || expandText}
      </div>
    );
  };

  const renderExpandedOption = () => (
    <>
      <div className={[s.row, styles.perso].join(' ')}>
        {renderExpandTextOpen()}
        <div className={[s.text_right, s.col_2].join(' ')}>
          <span onClick={toggleExpand} className={styles.butoon}>
            <MdExpandLess size={30} />
          </span>
        </div>
      </div>
    </>
  );

  const renderCollapsedOption = () => (
    <>
      <div className={s.row}>
        {renderExpandText()}
        <div className={[s.text_right, s.col_2].join(' ')}>
          <span onClick={toggleExpand} className={styles.butoon}>
            <MdExpandMore size={30} />
          </span>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className={[s.card, styles.container, s.row].join(' ')}>
        <span className={[styles.stile, s.col_xl_12, s.card_header].join(' ')}>
          {isExpanded ? renderExpandedOption() : renderCollapsedOption()}
        </span>
        <div className={[s.accordion, s.col_xl_12, styles.bodyCon].join(' ')}>
          {isExpanded ? children : null}
        </div>
      </div>
    </>
  );
};

export default Collapse;
